// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- RxJs
import { BehaviorSubject, Observable } from 'rxjs';

// --- HS Code
import { OidcService } from '../account/oidc.service';
import {
  ImpersonationTokenValidationModel,
  ImpersonationValidationStages,
} from '../../../models';

// #endregion

@Injectable({
  providedIn: 'root',
})
export abstract class ImpersonationValidationBaseService {
  protected _validationStage$: BehaviorSubject<ImpersonationValidationStages>;
  get validationStage$(): Observable<ImpersonationValidationStages> {
    return this._validationStage$;
  }

  protected _validation$: BehaviorSubject<ImpersonationTokenValidationModel | null>;
  get validation$(): Observable<ImpersonationTokenValidationModel | null> {
    return this._validation$;
  }

  constructor(protected oidcService: OidcService) {
    this._validationStage$ = new BehaviorSubject<ImpersonationValidationStages>(
      ImpersonationValidationStages.validatingToken
    );
    this._validation$ = new BehaviorSubject<ImpersonationTokenValidationModel | null>(null);
  }

  protected _authenticateFromOtac(otac: string) {
    this._validationStage$.next(ImpersonationValidationStages.authenticating);
    this.oidcService.signInRedirect({
      extraQueryParams: {
        acr_values: 'otac:' + otac,
      },
    });
  }

  abstract validateImpersonationToken(id: string): void;
}
